export default {
  LOAD_STUDY_PROGRAM_THEORETICAL_PART_FORM_PAGE_START: 'LoadStudyProgramTheoreticalPartFormPageStart',
  LOAD_STUDY_PROGRAM_THEORETICAL_PART_FORM_PAGE_END: 'LoadStudyProgramTheoreticalPartFormPageEnd'
};